import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddTeamLayer from "../components/AddTeamLayer";
 
 
const AddTeamPage = () => {
  return (
    <>
   
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Team  </h5><Breadcrumb title="Add Team" /></div>
 
        {/* CalendarMainLayer */}
        <AddTeamLayer />
 
 
    </>
  );
};
 
export default AddTeamPage;
 
 